import script from "./GameOverScreen.vue?vue&type=script&setup=true&lang=ts"
export * from "./GameOverScreen.vue?vue&type=script&setup=true&lang=ts"

import "./GameOverScreen.vue?vue&type=style&index=0&id=4dcaeaa1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4dcaeaa1"]])

export default __exports__